import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { MediaOverlay } from ".";
import { useMediumImages } from "@/gallery/hooks";
export const MediaPreview = ({ media, onSelectMedia, BoxProps, }) => {
    var _a, _b;
    /**
     * We use the first image as preview for the RichMedia
     *
     * Note: this behavior is implemented on the BFF media section
     * but the image returned was not optimized as "medium size"
     */
    const previewUrl = (_b = (_a = useMediumImages()) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.url;
    const aspectRatio = "4 / 3";
    const onClick = () => {
        onSelectMedia(media);
    };
    return (_jsxs(Box, { borderRadius: "radius.16", width: "100%", height: "100%", position: "relative", onClick: onClick, ...BoxProps, children: [_jsx(MediaOverlay, { media: media, onClick: onClick }), previewUrl && (_jsx(Box, { as: "img", src: previewUrl, borderRadius: "radius.16", cursor: "pointer", objectFit: "cover", unsafe_style: {
                    aspectRatio,
                }, width: "100%", loading: "lazy" }))] }));
};
